<template>
  <div class="container">
    <a-form-model
      class="content"
      ref="ruleForm"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item label="费用所属日期" required prop="finance_date">
        <a-date-picker v-model="form.finance_date" type="date" />
      </a-form-model-item>
      <a-form-model-item label="项目" prop="project_id">
        <a-select
          showSearch
          :filterOption="filterOption"
          optionFilterProp="children"
          v-model="form.project_id"
          @change="selectedPro"
        >
          <a-select-option
            v-for="item in proList"
            :key="item.id"
            :value="item.id"
            >{{ item.project_name }}</a-select-option
          >
        </a-select>
      </a-form-model-item>
      <a-form-model-item v-show="form.project_id != ''" label="公司">
        <p>{{ details.company_name }}</p>
      </a-form-model-item>
      <a-form-model-item v-show="form.project_id != ''" label="客户">
        <p>{{ details.customer_name }}</p>
      </a-form-model-item>
      <a-form-model-item label="费用大类" prop="pid">
        <a-select
          @change="selectedPID"
          v-model="form.pid"
          showSearch
          :filterOption="filterOption"
          optionFilterProp="children"
        >
          <a-select-option
            v-for="item in parentsList"
            :key="item.id"
            :value="item.id"
            >{{ item.name }}</a-select-option
          >
        </a-select>
      </a-form-model-item>
      <a-form-model-item
        v-show="form.pid != ''"
        label="费用类型"
        prop="finance_type_id"
      >
        <a-select
          v-model="form.finance_type_id"
          showSearch
          :filterOption="filterOption"
          optionFilterProp="children"
        >
          <a-select-option
            v-for="item in typeList"
            :key="item.id"
            :value="item.id"
            >{{ item.name }}</a-select-option
          >
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="费用金额" prop="amount">
        <a-input-number
          v-show="details.status != 50"
          v-model="form.amount"
          :min="0"
          style="width:150px"
        />
        <p v-show="details.status == 50">{{ form.amount }}</p>
      </a-form-model-item>
      <a-form-model-item
        :label="details.type == 1 ? '入账日期' : '出账日期'"
        required
        prop="flow_date"
      >
        <a-date-picker v-model="form.flow_date" type="date" />
      </a-form-model-item>
      <a-form-model-item
        :label="details.type == 1 ? '入账账户' : '出账账户'"
        required
        prop="company_id"
      >
        <a-select v-model="form.company_id" show-search style="width: 60%">
          <a-select-option
            v-for="item in companyList"
            :key="item.id"
            :value="item.id"
            >{{ item.company_name }}</a-select-option
          >
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="银行流水编号" prop="bank_flow_num">
        <a-input style="width:60%" v-model="form.bank_flow_num" />
      </a-form-model-item>
      <a-form-model-item :wrapper-col="{ span: 10, offset: 5 }">
        <a-button style="margin-right: 20px" @click="resetForm">重置</a-button>
        <a-button type="primary" @click="onSubmit">提交</a-button>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>
<script>
import moment from "moment";
import axios from "axios";
export default {
  data() {
    return {
      labelCol: { span: 5 },
      wrapperCol: { span: 12 },
      other: "",
      form: {
        finance_date: moment().format("YYYY-MM-DD"),
        project_id: "",
        pid: "",
        finance_type_id: "",
        name: "",
        amount: "",
        detail: "",
        invoice_date: "",
        flow_date: moment().format("YYYY-MM-DD"),
        company_id: "",
        bank_flow_num: ""
      },
      proList: [],
      customerName: "",
      companyName: "",
      parentsList: [],
      typeList: [],
      rules: {
        project_id: [
          {
            required: true,
            message: "请选择项目",
            trigger: "change"
          }
        ],
        company_id: [
          {
            required: true,
            message: "请选择账户",
            trigger: "change"
          }
        ],
        pid: [
          {
            required: true,
            message: "请选择费用大类",
            trigger: "change"
          }
        ],
        finance_type_id: [
          {
            required: true,
            message: "请选择费用类型",
            trigger: "change"
          }
        ],
        bank_flow_num: [
          {
            required: true,
            message: "请输入银行流水",
            trigger: "blur"
          }
        ]
      },
      details: {},
      companyList: []
    };
  },
  mounted() {
    this.getPro(); //获取项目
    this.getParents(); //获取大类
    this.getCompany(); //主体账户
    if (this.repairDataDetails != undefined) {
      this.getDetails();
    }
  },
  props: {
    repairDataDetails: {}
  },
  watch: {
    repairDataDetails() {
      this.getDetails();
    }
  },
  methods: {
    getCompany() {
      let url =
        this.httpsBasic.url + this.httpsBasic.customer + "Company/companyList";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          per_page: 100000
        })
        .then(res => {
          if (res.data.code == 200) {
            this.companyList = res.data.data.data;
            // console.log(this.companyList);
          }
        });
    },
    getDetails() {
      this.details = this.repairDataDetails;
      // console.log(this.details);
      let company_id = "";
      if (this.details.type == 1) {
        this.details.finance_flow_list != undefined &&
        this.details.finance_flow_list != ""
          ? (company_id = this.details.finance_flow_list[0].to_company_id)
          : (company_id = "");
      } else {
        this.details.finance_flow_list != undefined &&
        this.details.finance_flow_list != ""
          ? (company_id = this.details.finance_flow_list[0].company_id)
          : (company_id = "");
      }
      this.form = {
        type: this.details.type,
        finance_date: this.details.finance_date,
        project_id: this.details.project_id,
        pid: this.details.pid,
        finance_type_id: this.details.finance_type_id,
        name: this.details.name,
        amount: Number(this.details.amount),
        detail: this.details.detail,
        invoice_date: this.details.invoice_date,
        flow_date:
          this.details.finance_flow_list != undefined &&
          this.details.finance_flow_list != ""
            ? this.details.finance_flow_list[0].flow_date.substring(0, 10)
            : "",
        company_id: company_id,
        bank_flow_num: this.details.bank_flow_num
      };
      this.getType(); //获取类型
    },
    selectedPID() {
      this.form.finance_type_id = "";
      this.getType(); //获取类型
    },
    getParents() {
      let url =
        this.httpsBasic.url + this.httpsBasic.finance + "Finance_type/getLeave";
      let params = {
        token: window.localStorage.getItem("xnwfPcToken"),
        pid: 0
      };
      axios.post(url, params).then(res => {
        if (res.data.code == 200) {
          this.parentsList = res.data.data;
          // console.log(this.parentsList);
        }
      });
    },
    getType() {
      let url =
        this.httpsBasic.url + this.httpsBasic.finance + "Finance_type/getLeave";
      let params = {
        token: window.localStorage.getItem("xnwfPcToken"),
        pid: this.form.pid,
        finance_source_id: 1
      };
      axios.post(url, params).then(res => {
        if (res.data.code == 200) {
          this.typeList = res.data.data;
          // console.log(this.typeList);
        }
      });
    },
    getPro() {
      let url =
        this.httpsBasic.url + this.httpsBasic.trade + "Project/projectList";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          per_page: 100000
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proList = res.data.data.data;
          }
        });
    },
    selectedPro(val) {
      this.proList.forEach(element => {
        if (element.id == val) {
          this.companyName = element.company_name;
          this.customerName = element.customer_info.customer_name;
        }
      });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let params = {
            token: window.localStorage.getItem("xnwfPcToken"),
            finance_type_id: this.form.finance_type_id,
            project_id: this.form.project_id,
            id: this.details.id,
            flow_date:
              this.form.flow_date.length == 10
                ? this.form.flow_date
                : moment(this.form.flow_date).format("YYYY-MM-DD"),
            finance_date:
              this.form.finance_date.length == 10
                ? this.form.finance_date
                : moment(this.form.finance_date).format("YYYY-MM-DD"),
            company_id: this.form.company_id,
            bank_flow_num: this.form.bank_flow_num
          };
          if (this.form.type != 1) {
            delete params.invoice_date;
          }
          // console.log(params);
          let url =
            this.httpsBasic.url +
            this.httpsBasic.finance +
            "finance/updateInfoById";
          axios
            .post(url, params)
            .then(res => {
              if (res.data.code == 200) {
                this.$message.success("修复成功");
                this.$emit("hideInRepairDataPage", false);
              } else {
                this.$message.warning(res.data.message);
              }
            })
            .catch(err => {
              this.$message.error("服务器出错了...");
            });
        } else {
          // console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    }
  }
};
</script>
<style lang="less" scoped>
.content {
  margin-top: 30px;
  padding-bottom: 50px;
  .ant-form-item {
    margin-bottom: 14px;
  }
}
</style>
